import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, EffectFade]);

export function gallery(el) {
  new Swiper(el, {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    grabCursor: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction', 
      renderFraction: function(currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span> of <span class="' + totalClass + '"></span>';
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}
